module.exports = __webpack_public_path__ + "static/media/darth-vader.08c20768.png";